import { useState } from "react";
import Plus from "../../assets/icons/Plus";
import { Download } from "../../assets/icons/Download";
import Edit from "../../assets/icons/Edit";
import Delete from "../../assets/icons/Delete";
import ArrowLeftWithBody from "../../assets/icons/ArrowLeftWithBody";
import DefaultButton from "../default-button/DefaultButton";

export interface Lesson {
    id: number;
    date: string;
    averageScore: number;
}

interface AttendanceLessonsListProps {
    lessons: Lesson[];
    selectedLesson: Lesson | undefined;
    onLessonSelect?: (lesson: Lesson | undefined) => void;
    onCreateLesson?: () => void;
}

// Mock data - should come from API
const mockLessons: Lesson[] = [
    { id: 1, date: "06.08.2024", averageScore: 4.8 },
    { id: 2, date: "05.08.2024", averageScore: 4.7 },
    { id: 3, date: "02.08.2024", averageScore: 4.9 },
    { id: 4, date: "01.08.2024", averageScore: 4.5 },
    { id: 5, date: "31.07.2024", averageScore: 4.6 },
];


const Buttons = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-1">
            <div className="flex items-center justify-center border-none rounded-md bg-white">
                <DefaultButton Icon={Edit}
                    additionalStyle="p-[2px] text-valley-gray rounded-md text-[13px] font-semibold border-none bg-valley-blue/20"
                />
            </div>
            <div className="flex items-center justify-center border-none rounded-md bg-white">
                <DefaultButton Icon={Delete}
                    additionalStyle="p-[2px] text-valley-red rounded-md text-[13px] font-semibold border-none bg-valley-red/20"
                />
            </div>
        </div>
    )
}

export default function AttendanceLessonsList({
    lessons, 
    selectedLesson,
    onLessonSelect,
    onCreateLesson,
}: AttendanceLessonsListProps) {


    return (
        <div className="bg-white rounded-lg p-4 flex flex-col h-full min-h-0 overflow-hidden">
          <div className="flex items-center justify-between py-1 px-2 flex-shrink-0 flex-wrap gap-2">
            {
                selectedLesson && (
                    <div className="cursor-pointer bg-valley-gray rounded-[6px] p-1 text-white flex-shrink-0"
                        onClick={() => onLessonSelect?.(undefined)}
                    >
                        <ArrowLeftWithBody/>
                    </div>
                )
            }
            
            <div className="text-xl md:text-2xl font-semibold">
                Посещаемость курса
            </div>
            <div>
                <DefaultButton buttonText="Создать урок" Icon={Plus} additionalStyle="text-valley-dark-green border border-valley-dark-green rounded-lg py-2 px-2 md:px-3 text-sm md:text-base whitespace-nowrap" onClick={onCreateLesson} />
            </div>
          </div>

            <div className="flex-1 overflow-auto min-h-0 mt-4">
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse min-w-[400px]">
                        <thead>
                            <tr className="border-b border-valley-background-blue text-valley-gray text-xs md:text-sm font-medium">
                                <th className="text-left py-2 px-2 md:px-4">Дата</th>
                                <th className="text-left py-2 px-2 md:px-4">Средний балл</th>
                                <th className="text-center py-2 px-2 md:px-4"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {lessons.map((lesson) => (
                                <tr key={lesson.id} className={`border-b border-valley-background-blue ${selectedLesson?.id === lesson.id ? 'bg-valley-main text-white' : 'text-valley-black hover:bg-valley-background-blue cursor-pointer'}`}
                                    onClick = {() => onLessonSelect?.(lesson)}
                                >
                                    <td className="text-left py-2 px-2 md:px-4 text-sm">{lesson.date}</td>
                                    <td className="text-left py-2 px-2 md:px-4 text-sm">{lesson.averageScore}</td>
                                    <td className="py-2 px-2 md:px-4">
                                        <div className="flex items-center justify-end gap-1 flex-wrap">
                                           <DefaultButton buttonText="Скачать отчёт" additionalStyle={`${selectedLesson?.id === lesson.id ? 'bg-valley-main text-white' : 'text-valley-main bg-white border border-valley-main'} rounded-lg py-1 px-2 md:px-3 text-xs md:text-[13px] font-semibold whitespace-nowrap`} onClick={(e) => { e.stopPropagation(); }} />
                                           <Buttons/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
          
        </div>
    );
}

